import { ListItemIcon, ListItemText, MenuItem, MenuItemProps } from "@material-ui/core";
import CustomRouterLink from "components/CustomRouterLink/CustomRouterLink";
import React, { ElementType, Fragment, ReactNode, useCallback, useMemo } from "react";
import { topBarSubMenuItemStyles } from './style';

export interface ITopBarSubMenuItem {
  label: string;
  icon?: ReactNode | ElementType;
  path?: string;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  disabled?: boolean;
}

interface Props extends ITopBarSubMenuItem {
  onClose: Function
}

export default React.forwardRef<MenuItemProps, Props>((
  {
    label,
    icon,
    path,
    onClick,
    onClose,
    disabled,
    ...props
  },
  ref
) => {

  const classes = topBarSubMenuItemStyles();

  const getIcon = useCallback(() => {
    if (typeof icon === 'function') {
      const Component: any = icon;
      return <Component />;
    }
    return icon;
  }, [icon])

  const content = useMemo(() => {
    return (
      <Fragment>
        {
          icon ? (
            <ListItemIcon className={ classes.icon }>
              {getIcon()}
            </ListItemIcon>
          )
           : null
        }
        <ListItemText primary={label} classes={{primary: classes.label}} />
      </Fragment>
    )
  }, [icon, label, classes, getIcon])

  const onClicked = useCallback((event: React.MouseEvent<HTMLElement>) => {
    onClose();
    if (typeof onClick === 'function') {
      onClick(event);
    }
  }, [onClose, onClick])

  return path ? (
    <MenuItem
      ref={ref}
      className={classes.wrapper}
      button
      component={ CustomRouterLink }
      to={ path }
      onClick={ onClicked }
      disabled={ disabled }
    >
      { content }
    </MenuItem>
  ) : (
    <MenuItem
      button
      className={classes.wrapper}
      onClick={ onClicked }
      disabled={ disabled }
    >
      { content }
    </MenuItem>
  )
})